import BalancesReport from './BalancesReport.redux';

export default BalancesReport;
